import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";
import { OfficeSelectorService } from "src/app/common/officeSelector/officeSelector.service";
import { KpiService } from "src/app/dashboardCommon/services/kpiService";
import { WorkersAppealKpiCfg, WorkersAppealKpiCfgService } from "./workersAppealKpiCfg.service";
import { KpiServiceError, KpiServiceErrorType } from "src/app/dashboardCommon/services/kpiServiceError";
import moment from 'moment';

export class WorkersAppealDetailServiceDataItem {
    public pPranchId: String;
    public workerId: number;
    public orderId: number;
    public nif: string;
    public name: string;
    public requestedJob: string;
    public totOrders: number;
    public ctoBegDate: Date;
    public totWorkerCallStatusId: number;
    public allName: string;
    public mobilePhone: string;
    public email: string;
    public clienteName: string;
    public currentCallDate?: Date;
    public expireDate?: Date;
}

export class WorkersAppealDetailServiceData{
    public workersAppeals: WorkersAppealDetailServiceDataItem[];
    public updateTimestamp: Date;
}

@Injectable()
export class WorkersAppealDetailService extends KpiService<WorkersAppealDetailServiceData>{
    public getClassName(): string {
        return "WorkersAppealDetailService";
    }

    constructor(
        private serviceCfg: WorkersAppealKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ){
        super(injector);
    }

    protected async update(): Promise<WorkersAppealDetailServiceData> {
        if (this.apigeeService.apiToken){
            let result: WorkersAppealDetailServiceData = null;
            try {
                let cfg: WorkersAppealKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.workersAppeal.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.get<WorkersAppealDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }

}
